//@flow
import React from 'react';
import { HiverAxios, showMessage } from 'h-commons';
import { INVITE_EMAIL_DONE, INVITE_EMAIL_INIT, INVITE_EMAIL_FAILED } from './types';

export const inviteUsers = (emails: Array<string>, callback: Function) => (dispatch: Function) => {
    dispatch({
        type: INVITE_EMAIL_INIT
    });
    HiverAxios({
        url: '/api/settings/users',
        type: "POST",
        params: {
            "userinvites": emails
        },
        callback: response => {
            if (response.data && response.data.success) {
                const message = () => {
                    return (
                        <div className='h-sm-create-instruction'>
                            <span className='h-mt-13p'>
                                {`${emails.length} new user${emails.length > 1 ? 's' : ''} invited`}
                            </span>
                            <br />
                            <span className='h-mt-6p h-mb-6p'>
                                Head over to the Shared Mailbox section to
                            <br />
                                add the new users to those as needed.
                            <br />
                            </span>

                        </div>
                    )
                }
                showMessage({
                    message: message(),
                    type: 'success',
                    autoClose: 10000
                });
                dispatch({
                    type: INVITE_EMAIL_DONE,
                    payload: emails
                });
                callback(true);
            } else {
                dispatch({
                    type: INVITE_EMAIL_FAILED
                });
                showMessage({
                    message: 'Failed to invite users',
                    type: 'error'
                });

                callback(false);
            }
        },
        onfail: (err) => {
            dispatch({
                type: INVITE_EMAIL_FAILED
            });
            showMessage({
                message: 'Failed to invite users',
                type: 'error'
            });
            callback(false);
        }
    })
}

const styles = {

}